export type QualityPreset = 'low' | 'medium' | 'high' | 'auto';

export interface QualityConfig {
  pixelRatioCap: number;
  shadowMapSize: number;
  shadows: boolean;
  antialias: boolean;
  particlesDensity: number;
  maxTrianglesTarget: number;
  maxDrawCallsTarget: number;
  bloom: boolean;
  waterReflections: boolean;
  instancedFoliageDensity: number;
}

export const QUALITY_CONFIGS: Record<'low' | 'medium' | 'high', QualityConfig> = {
  low: {
    pixelRatioCap: 1.0,
    shadowMapSize: 512,
    shadows: false,
    antialias: false,
    particlesDensity: 0.35,
    maxTrianglesTarget: 150000,
    maxDrawCallsTarget: 100,
    bloom: false,
    waterReflections: false,
    instancedFoliageDensity: 0.4,
  },
  medium: {
    pixelRatioCap: 1.5,
    shadowMapSize: 1024,
    shadows: true,
    antialias: true,
    particlesDensity: 0.75,
    maxTrianglesTarget: 350000,
    maxDrawCallsTarget: 180,
    bloom: true,
    waterReflections: false,
    instancedFoliageDensity: 0.75,
  },
  high: {
    pixelRatioCap: 2.0,
    shadowMapSize: 2048,
    shadows: true,
    antialias: true,
    particlesDensity: 1.0,
    maxTrianglesTarget: 500000,
    maxDrawCallsTarget: 250,
    bloom: true,
    waterReflections: true,
    instancedFoliageDensity: 1.0,
  },
};
